<template>
  <div id="test3dkyj" class="animated fadeIn h-100">
    <div
      style="background: red; display: flex; flex-direction: column; flex- width: 100%; height: 100%"
    >
      <div
        style="
          background: blue;
          display: flex;
          flex-direction: row;
          width: 100%;
          height: 100px;
        "
      >
        <b-button @click="resetCamera">Reset Camera</b-button>
        <b-button @click="setAutoRotation">{{
          isAutoRotation ? "Auto Rotation On" : "Auto Rotation Off"
        }}</b-button>
        <b-button @click="setOnOffSensor1">{{
          isOnOffSensor1 ? "Sensor1 On" : "Sensor1 Off"
        }}</b-button>
        <b-button @click="setOnOffSensor2">{{
          isOnOffSensor2 ? "Sensor2 On" : "Sensor2 Off"
        }}</b-button>
        <b-button @click="setOnOffSunlight">{{
          isOnOffSunlight ? "태양광 On" : "태양광 Off"
        }}</b-button>
        <b-button @click="setColorSensor1">{{
          isColorSensor1 ? "Sensor1 Color On" : "Sensor1 Color Off"
        }}</b-button>
        <b-button @click="setColorSensor2">{{
          isColorSensor2 ? "Sensor2 Color On" : "Sensor2 Color Off"
        }}</b-button>
        <b-button @click="setColorSunlight">{{
          isColorSunlight ? "태양광 Color On" : "태양광 Color Off"
        }}</b-button>
        <b-button @click="moveCamera(sensor1Id, 90, 180, 0)"
          >Sensor1 보기</b-button
        >
        <b-button @click="moveCamera(sensor2Id, 90, 180, 0)"
          >Sensor2 보기</b-button
        >
        <b-button @click="moveCamera(sunlightId, 180, 90, 0)"
          >태양광 보기</b-button
        >
        <b-button @click="setImage">이미지 넣기</b-button>
        <b-button @click="setImage2">이미지 넣기2</b-button>
        <b-button @click="setTest">테스트 위치 변경</b-button>
        <b-button @click="setTest2">테스트 Mesh 복사</b-button>
        <b-button @click="download">다운로드</b-button>
        <b-form-select
          v-model="controlType"
          :options="controlTypeOptions"
          @change="changeControlType"
          style="width: 250px; align-self: center"
        ></b-form-select>
      </div>

      <div
        style="
          background: yellow;
          display: flex;
          flex-direction: column;
          width: 100%;
          height: calc(100% - 100px);
        "
      >
        <canvas ref="renderCanvas" style="width: 100%; height: 100%"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

/** babylon 라이브러리 */
import * as BABYLON from "babylonjs";
/** babylon 라이브러리 */

/** 외부 glb 파일 import 시키기 위한 라이브러리 */
import * as BABYLON_LOADER from "babylonjs-loaders";
/** 외부 glb 파일 import 시키기 위한 라이브러리 */

/** 현재 mesh를 .glb 파일로 다운로드 받기 위한 라이브러리 */
import * as BABYLON_SERIALIZERS from "babylonjs-serializers";
/** 현재 mesh를 .glb 파일로 다운로드 받기 위한 라이브러리 */

export default {
  components: {
    BABYLON,
    BABYLON_LOADER,
    BABYLON_SERIALIZERS,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getAlertOptions",
      "getConfirmOptions",
    ]),
  },
  data() {
    return {
      scene: null,
      engine: null,
      camera: null,
      mainMesh: null,
      sensor1Id: "Mesh03",
      sensor2Id: "Mesh06",
      sunlightId: "Mesh23",
      isAutoRotation: true,
      isOnOffSensor1: true,
      isOnOffSensor2: true,
      isOnOffSunlight: true,
      isColorSensor1: false,
      isColorSensor2: false,
      isColorSunlight: false,

      gizmoManager: null,
      selectedMesh: null,
      controlType: null,
      controlTypeOptions: [
        { value: null, text: "선택" },
        { value: "boundingBox", text: "boundingBox" },
        { value: "position", text: "position" },
        { value: "scale", text: "scale" },
        { value: "rotation", text: "rotation" },
      ],

      newInstance: null,
      models: {},
      instCount: 0,

      LoadYn: false,
    };
  },
  beforeMount() {
    /** babylon을 init 하기전에 타임아웃을 줘야함(DOM이 완전히 로드 된 상태에서 해야되는걸로 추측 타임을 0으로 줘도 현재까지는 무관) */
    setTimeout(() => {
      this.initBabylon();
    }, 0);
    /** babylon을 init 하기전에 타임아웃을 줘야함(DOM이 완전히 로드 된 상태에서 해야되는걸로 추측 타임을 0으로 줘도 현재까지는 무관) */
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    initBabylon() {
      /** babylon engine을 초기에 생성해야됨(3d를 그려줄 canvas 주입) */
      this.engine = new BABYLON.Engine(this.$refs.renderCanvas, true, {
        preserveDrawingBuffer: true,
        stencil: true,
      });
      /** babylon engine을 초기에 생성해야됨(3d를 그려줄 canvas 주입) */

      let createScene = () => {
        /** engine에서 scene 생성 */
        let scene = new BABYLON.Scene(this.engine);
        /** engine에서 scene 생성 */

        /** ------------------------------------------------------------ camera ------------------------------------------------------------ */
        /** camera를 뭐로 쓸지 선택 후 camera 생성(ArcRotateCamera가 x, y, z를 전부 보는 3d 카메라) */
        this.camera = new BABYLON.ArcRotateCamera(
          "camera",
          BABYLON.Tools.ToRadians(90),
          BABYLON.Tools.ToRadians(65),
          10,
          BABYLON.Vector3.Zero(),
          scene
        );
        /** camera를 뭐로 쓸지 선택 후 camera 생성(ArcRotateCamera가 x, y, z를 전부 보는 3d 카메라) */

        this.camera.setTarget(BABYLON.Vector3.Zero());
        this.camera.attachControl(this.$refs.renderCanvas, true);

        this.camera.useAutoRotationBehavior = this.isAutoRotation;
        this.camera.zoomToMouseLocation = true;
        this.camera.allowUpsideDown = false;

        // this.camera.wheelDeltaPercentage = 0.1
        // this.camera.wheelPrecision = 100
        // this.camera.pinchPrecision = 1

        // this.camera.angularSensibility = 1
        // this.camera.moveSensibility = 1

        // this.camera.targetScreenOffset.x = 1
        // this.camera.targetScreenOffset.y = 1

        // this.camera.lowerRadiusLimit = 1
        // this.camera.upperRadiusLimit = 100

        this.camera.wheelDeltaPercentage = 0.01;
        // this.camera.upperRadiusLimit = 20;
        // this.camera.lowerRadiusLimit = 0.01;
        this.camera.inertia = 0.8;
        this.camera.minZ = 0.01;

        // this.camera.applyGravity = true;
        /** ------------------------------------------------------------ camera ------------------------------------------------------------ */

        /** ------------------------------------------------------------ light(밝기 조절) ------------------------------------------------------------ */
        let hemisphericLight = new BABYLON.HemisphericLight(
          "hemisphericLight",
          new BABYLON.Vector3(0, 1, 0),
          scene
        );
        console.debug(hemisphericLight);

        let directionalLight = new BABYLON.DirectionalLight(
          "directionalLight",
          new BABYLON.Vector3(0, 1, 0),
          scene
        );
        console.debug(directionalLight);
        /** ------------------------------------------------------------ light ------------------------------------------------------------ */

        /** ------------------------------------------------------------ basic ground ------------------------------------------------------------ */
        // let groundMat = new BABYLON.StandardMaterial("groundMat")
        // // groundMat.diffuseColor = new BABYLON.Color3(0, 1, 0)
        // groundMat.diffuseTexture = new BABYLON.Texture("static/babylon/ground/soil.jpg")

        // let ground = BABYLON.MeshBuilder.CreateGround("ground", { width: 10, height: 10, subdivisions: 2, updatable: false }, scene)
        // ground.material = groundMat
        /** ------------------------------------------------------------ basic ground ------------------------------------------------------------ */

        /** ------------------------------------------------------------ custom ground(바닦 mesh 설정) ------------------------------------------------------------ */
        let largeGroundMat = new BABYLON.StandardMaterial("largeGroundMat");
        largeGroundMat.diffuseTexture = new BABYLON.Texture(
          "static/babylon/ground/valleygrass.png"
        );

        let largeGround = BABYLON.MeshBuilder.CreateGroundFromHeightMap(
          "largeGround",
          "static/babylon/ground/villageheightmap.png",
          {
            width: 150,
            height: 150,
            subdivisions: 20,
            minHeight: 0,
            maxHeight: 10,
          }
        );
        largeGround.material = largeGroundMat;
        /** ------------------------------------------------------------ custom ground ------------------------------------------------------------ */

        /** ------------------------------------------------------------ sky(전체적인 공간 mesh 설정) ------------------------------------------------------------ */
        let skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
        skyboxMaterial.backFaceCulling = false;
        skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture(
          "static/babylon/skybox/skybox",
          scene
        );
        skyboxMaterial.reflectionTexture.coordinatesMode =
          BABYLON.Texture.SKYBOX_MODE;
        skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
        skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);

        let skybox = BABYLON.MeshBuilder.CreateBox(
          "skyBox",
          { size: 150 },
          scene
        );
        skybox.material = skyboxMaterial;
        /** ------------------------------------------------------------ sky ------------------------------------------------------------ */

        /** ------------------------------------------------------------ mesh controller ------------------------------------------------------------ */
        this.gizmoManager = new BABYLON.GizmoManager(scene);
        this.gizmoManager.boundingBoxGizmoEnabled = false;
        this.gizmoManager.positionGizmoEnabled = false;
        this.gizmoManager.scaleGizmoEnabled = false;
        this.gizmoManager.rotationGizmoEnabled = false;
        this.gizmoManager.usePointerToAttachGizmos = false;
        /** ------------------------------------------------------------ mesh controller ------------------------------------------------------------ */

        /** ------------------------------------------------------------ add glf file ------------------------------------------------------------ */
        BABYLON.SceneLoader.Append(
          "static/babylon/",
          "3dtestkyj.glb",
          scene,
          (newMeshes) => {
            this.mainMesh = newMeshes;
            console.log(newMeshes.meshes);
          }
        );
        /** ------------------------------------------------------------ add glf file ------------------------------------------------------------ */

        /** ------------------------------------------------------------ mouse event double click(mesh control) ------------------------------------------------------------ */
        scene.onPointerObservable.add((pointerInfo) => {
          switch (pointerInfo.type) {
            case BABYLON.PointerEventTypes.POINTERDOUBLETAP:
              if (this.selectedMesh) {
                /** mesh가 이미 선택되어 있으면 컨트롤러를 제거 */
                this.gizmoManager.attachToMesh(null);
                this.clearSelectedMeshColor();
                /** mesh가 이미 선택되어 있으면 컨트롤러를 제거 */
              } else {
                /** 이전에 선택한 mesh가 없고 마우스로 더블클릭한 item이 mesh일 경우 더블 클릭한 mesh를 가져와 색상 변경 및 컨트롤러 적용 */
                if (pointerInfo.pickInfo.hit) {
                  if (
                    pointerInfo.pickInfo.pickedMesh &&
                    pointerInfo.pickInfo.pickedMesh.name
                  ) {
                    if (
                      pointerInfo.pickInfo.pickedMesh.name.includes("Mesh") ||
                      pointerInfo.pickInfo.pickedMesh.name.includes("Group")
                    ) {
                      this.selectedMesh = pointerInfo.pickInfo.pickedMesh;
                      this.selectedMesh.overlayColor.r = 0;
                      this.selectedMesh.overlayColor.g = 0;
                      this.selectedMesh.overlayColor.b = 255;
                      this.selectedMesh.renderOverlay = true;

                      console.log(this.selectedMesh);

                      // this.gizmoManager.attachableMeshes = [this.selectedMesh];
                      this.gizmoManager.attachToMesh(this.selectedMesh);
                    }
                  }
                }
                /** 이전에 선택한 mesh가 없고 마우스로 더블클릭한 item이 mesh일 경우 더블 클릭한 mesh를 가져와 색상 변경 및 컨트롤러 적용 */
              }
              break;
          }
        });
        /** ------------------------------------------------------------ mouse event double click ------------------------------------------------------------ */

        return scene;
      };

      /** 생성한 scene를 root에서 갖고있는다(외부에서 이것저것 컨트롤 하기 위함) */
      this.scene = createScene();
      /** 생성한 scene를 root에서 갖고있는다(외부에서 이것저것 컨트롤 하기 위함) */

      /** engine의 렌더링이 끝날 경우 scene를 렌더링 */
      this.engine.runRenderLoop(() => {
        this.scene.render();
      });
      /** engine의 렌더링이 끝날 경우 scene를 렌더링 */

      /** window 사이즈가 변경될 시 babylon의 화면도 맞추기 위함 */
      window.addEventListener("resize", () => {
        this.engine.resize();
      });
      /** window 사이즈가 변경될 시 babylon의 화면도 맞추기 위함 */
    },
    resetCamera() {
      /** 초기에 설정한 카메라 세팅으로 다시 원복시킨다. zoom 또한 마찬가지 */
      BABYLON.Animation.CreateAndStartAnimation(
        "moveTarget",
        this.camera,
        "target",
        30,
        30,
        this.camera.target,
        BABYLON.Vector3.Zero(),
        0
      );
      BABYLON.Animation.CreateAndStartAnimation(
        "moveAlpha",
        this.camera,
        "alpha",
        30,
        30,
        this.camera.alpha,
        BABYLON.Tools.ToRadians(90),
        0
      );
      BABYLON.Animation.CreateAndStartAnimation(
        "moveBeta",
        this.camera,
        "beta",
        30,
        30,
        this.camera.beta,
        BABYLON.Tools.ToRadians(65),
        0
      );
      this.camera.radius = 10;
    },
    setAutoRotation() {
      /** 화면이 자동으로 돌아가는 모션을 on, off 시킬수 있다 */
      this.isAutoRotation = !this.isAutoRotation;
      this.camera.useAutoRotationBehavior = this.isAutoRotation;
    },
    setOnOffSensor1() {
      /** 첫번째 센서를 화면에 표시 및 제거한다. */
      this.isOnOffSensor1 = !this.isOnOffSensor1;

      let mesh = this.scene.getMeshByName(this.sensor1Id);
      mesh.setEnabled(this.isOnOffSensor1);
    },
    setOnOffSensor2() {
      /** 두번째 센서를 화면에 표시 및 제거한다. */
      this.isOnOffSensor2 = !this.isOnOffSensor2;

      let mesh = this.scene.getMeshByName(this.sensor2Id);
      mesh.setEnabled(this.isOnOffSensor2);
    },
    setOnOffSunlight() {
      /** 태양광을 화면에 표시 및 제거한다. */
      this.isOnOffSunlight = !this.isOnOffSunlight;

      let mesh = this.scene.getMeshByName(this.sunlightId);
      mesh.setEnabled(this.isOnOffSunlight);
    },
    setColorSensor1() {
      /** 첫번째 센서 색상을 변경한다.(renderOverlay에 적용된 색상으로 표시됨) */
      this.isColorSensor1 = !this.isColorSensor1;

      let mesh = this.scene.getMeshByName(this.sensor1Id);
      mesh.renderOverlay = this.isColorSensor1;
    },
    setColorSensor2() {
      /** 두번째 센서 색상을 변경한다.(renderOverlay에 적용된 색상으로 표시됨) */
      this.isColorSensor2 = !this.isColorSensor2;

      let mesh = this.scene.getMeshByName(this.sensor2Id);
      mesh.renderOverlay = this.isColorSensor2;
    },
    setColorSunlight() {
      /** 태양광 색상을 변경한다.(renderOverlay에 적용된 색상으로 표시됨) */
      this.isColorSunlight = !this.isColorSunlight;

      let mesh = this.scene.getMeshByName(this.sunlightId);
      mesh.renderOverlay = this.isColorSunlight;
    },
    moveCamera(id, alpha, bata, radius) {
      /** 선택한 mesh의 위치로 카메라가 이동한다.(mesh에서 좌표를 얻기가 힘들어 지정되어있는 위치를 대충 하드코딩함) */
      let mesh = this.scene.getMeshByName(id);

      BABYLON.Animation.CreateAndStartAnimation(
        "movePosition",
        this.camera,
        "position",
        30,
        30,
        this.camera.position,
        mesh.position,
        0
      );
      BABYLON.Animation.CreateAndStartAnimation(
        "moveAlpha",
        this.camera,
        "alpha",
        30,
        30,
        this.camera.alpha,
        BABYLON.Tools.ToRadians(alpha),
        0
      );
      BABYLON.Animation.CreateAndStartAnimation(
        "moveBeta",
        this.camera,
        "beta",
        30,
        30,
        this.camera.beta,
        BABYLON.Tools.ToRadians(bata),
        0
      );

      this.camera.focusOn([mesh], true);
      // this.camera.radius = radius
      this.setFlickerMesh(mesh);
    },
    setFlickerMesh(mesh) {
      /** 선택한 mesh의 색상을 주기위한(하이라이트를 표현하기 위해 interval이 들어감) */
      let count = 5;
      let highlightColorInterval = setInterval(() => {
        mesh.overlayColor.r = 255;
        mesh.overlayColor.g = 106;
        mesh.overlayColor.b = 0;

        mesh.renderOverlay = !mesh.renderOverlay;
        if (count === 0) {
          mesh.renderOverlay = false;

          mesh.overlayColor.r = 1;
          mesh.overlayColor.g = 0;
          mesh.overlayColor.b = 0;

          clearInterval(highlightColorInterval);
        }
        count--;
      }, 500);
    },
    clearSelectedMeshColor() {
      /** 선택되어 있는 mesh의 색상을 원복시킨다.(기존에 빨강색으로 들어있어서 다시 빨강색으로 원복 시킴) */
      if (this.selectedMesh) {
        this.selectedMesh.overlayColor.r = 1;
        this.selectedMesh.overlayColor.g = 0;
        this.selectedMesh.overlayColor.b = 0;

        switch (this.selectedMesh.name) {
          case this.sensor1Id:
            this.selectedMesh.renderOverlay = this.isColorSensor1;
            break;
          case this.sensor2Id:
            this.selectedMesh.renderOverlay = this.isColorSensor2;
            break;
          case this.sunlightId:
            this.selectedMesh.renderOverlay = this.isColorSunlight;
            break;
          default:
            this.selectedMesh.renderOverlay = false;
            break;
        }
      }
      this.selectedMesh = null;
    },
    setImage() {
      /** 이미지를 추가하기 위한 코드(임의로 추가하기 때문에 하드코딩 되어 있는 위치에 추가됨) */
      var f = new BABYLON.Vector4(0.5, 0, 1, 1); // front image = half the whole image along the width
      var b = new BABYLON.Vector4(0, 0, 0.5, 1); // back image = second half along the width

      var plane = BABYLON.MeshBuilder.CreatePlane(
        "plane",
        {
          height: 10,
          width: 10,
          sideOrientation: BABYLON.Mesh.DOUBLESIDE,
          frontUVs: f,
          backUVs: b,
        },
        this.mainMesh
      );

      var mat = new BABYLON.StandardMaterial("", this.mainMesh);
      mat.diffuseTexture = new BABYLON.Texture(
        "static/babylon/crack/crack1.jpg",
        this.mainMesh
      );
      plane.material = mat;
    },
    setImage2() {
      /** 특정 mesh에 이미지를 넣기 위한 코드(임의로 추가한거기 때문에 다리쪽에 이미지가 추가됨) */
      let mesh = this.scene.getMeshByName("Group3");
      console.log(mesh);

      var mat = new BABYLON.StandardMaterial("matkyj1", this.scene);
      mat.alpha = 1.0;
      // mat.diffuseColor = new BABYLON.Color3(1, 0, 0);
      var texture = new BABYLON.Texture(
        "static/babylon/crack/crack1.jpg",
        this.scene
      );
      mat.diffuseTexture = texture;

      mesh.material = mat;

      // var f = new BABYLON.Vector4(0.5, 0, 1, 1); // front image = half the whole image along the width
      // var b = new BABYLON.Vector4(0, 0, 0.5, 1); // back image = second half along the width

      // var plane = BABYLON.MeshBuilder.CreatePlane("plane1kyj2", { height: 1, width: 1, sideOrientation: BABYLON.Mesh.DOUBLESIDE, frontUVs: f, backUVs: b }, mesh);

      // var mat = new BABYLON.StandardMaterial("testkyj1", mesh);
      // mat.diffuseTexture = new BABYLON.Texture("static/babylon/crack/crack1.jpg", mesh);
      // plane.material = mat;
    },
    setTest() {
      /** 특정 mesh의 위치 조절을 확인하기 위한 코드 */
      let mesh = this.scene.getMeshByName(this.sunlightId);
      console.log(mesh.position);
      mesh.position.y = mesh.position.y + 0.1;
      mesh.position.z = mesh.position.z + 0.1;
    },
    setTest2() {
      /** 특정 mesh를 복사 하기위한 코드  */
      let mesh = this.scene.getMeshByName(this.sunlightId);

      // let cloneMesh = Object.assign({}, mesh.createInstance("house" + new Date()))
      let cloneMesh = mesh.createInstance("test_" + this.instCount);
      // this.newInstance = cloneMesh;
      // var target = BABYLON.Vector3.Unproject(
      //   new BABYLON.Vector3(this.scene.pointerX, this.scene.pointerY, 0),
      //   this.$refs.renderCanvas.width,
      //   this.$refs.renderCanvas.height,
      //   new BABYLON.Matrix.Identity(),
      //   this.camera.getViewMatrix(),
      //   this.camera.getProjectionMatrix()
      // );
      // target.x = this.camera.position.x - target.x;
      // target.y = this.camera.position.y - target.y;
      // target.z = this.camera.position.z - target.z;

      // var p = this.getZeroPlaneVector(this.camera.position, cloneMesh.target);
      // this.newInstance.position = p;

      this.instCount++;

      // cloneMesh.position.x = mesh.position.x
      // cloneMesh.position.y = mesh.position.y
      // cloneMesh.position.z = mesh.position.z
      // cloneMesh.position.x = 0
      // cloneMesh.position.y = 0
      // cloneMesh.position.z = 0

      let node = this.scene.getTransformNodeByName("Group9");
      console.log(node);
      console.log(mesh.parent);
      console.log(cloneMesh.parent);
      // cloneMesh.parent = node

      // evt.dataTransfer.setData("text", evt.target.src);
      // // will hide/remove the 'ghost'-image when we start dragging
      // evt.dataTransfer.setDragImage(new Image(), 0, 0);

      // let positions = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);

      // mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, positions)
    },
    changeControlType() {
      /** 다양한 컨트롤러를 선택해서 사용하기 위한 코드 */
      this.gizmoManager.boundingBoxGizmoEnabled = false;
      this.gizmoManager.positionGizmoEnabled = false;
      this.gizmoManager.scaleGizmoEnabled = false;
      this.gizmoManager.rotationGizmoEnabled = false;

      switch (this.controlType) {
        case "boundingBox":
          this.gizmoManager.boundingBoxGizmoEnabled = true;
          break;
        case "position":
          this.gizmoManager.positionGizmoEnabled = true;
          break;
        case "scale":
          this.gizmoManager.scaleGizmoEnabled = true;
          break;
        case "rotation":
          this.gizmoManager.rotationGizmoEnabled = true;
          break;
      }
    },
    download() {
      /** 현재 화면에 보여지는 mesh를 .glb 파일로 저장하기 위한 코드 */
      let options = {
        shouldExportNode: function (node) {
          console.log(node.id);
          return (
            node.id !== "camera" &&
            node.id !== "largeGround" &&
            node.id !== "skyBox" &&
            node.id !== "hemisphericLight" &&
            node.id !== "directionalLight"
          );
        },
      };

      BABYLON_SERIALIZERS.GLTF2Export.GLBAsync(
        this.scene,
        "test1",
        options
      ).then((glb) => {
        glb.downloadFiles();
      });
    },
    getZeroPlaneVector(pos, rot) {
      /** 좌표를 뽑기위한 계산식 아직 테스트중인데 잘안됨 */
      return this.getHorizontalPlaneVector(0, pos, rot);
    },
    getHorizontalPlaneVector(y, pos, rot) {
      /** 좌표를 뽑기위한 계산식 아직 테스트중인데 잘안됨 */
      if (!rot.y) {
        return null; // no solution, as it will never hit the zero plane
      }
      return new BABYLON.Vector3(
        pos.x - ((pos.y - y) * rot.x) / rot.y,
        0,
        pos.z - ((pos.y - y) * rot.z) / rot.y
      );
    },
  },
};
</script>

<style lang="scss">
#test3dkyj {
  padding: 15px;

  button {
    margin: 5px;
    border: 1px solid red;
    border-radius: 5px;
    height: 70px;
    align-self: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/test-3d-kyj/Test3dkyj.vue